var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BookcaseRegister"},[_c('img',{staticClass:"code",attrs:{"src":_vm.companyInfo.offiaccount_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("请扫码关注公众号进行注册")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0fbc156b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Bookcase/Common/Register.vue
// module id = null
// module chunks = 